import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="relative flex min-h-[70vh] flex-col items-center justify-center overflow-hidden px-4 py-16 text-center">
      <h1 className="pointer-events-none absolute bottom-0 select-none font-heading text-[9rem] font-black leading-none text-background-100 md:text-[13rem]">
        404
      </h1>
      <div className="relative z-10 flex flex-col items-center">
        <span className="flex h-14 w-14 items-center justify-center rounded-full bg-background-200/70 text-foreground-400">
          <i className="ri-film-line text-2xl" />
        </span>
        <h2 className="mt-4 font-heading text-xl font-semibold text-foreground-50 md:text-2xl">
          这个页面不存在
        </h2>
        <p className="mt-2 text-sm text-foreground-500">{location.pathname}</p>
        <p className="mt-2 max-w-md text-sm leading-relaxed text-foreground-500">
          页面可能已被移动或链接有误，回到首页继续浏览最新热门电影吧。
        </p>
        <div className="mt-6 flex flex-wrap justify-center gap-3">
          <Link
            to="/"
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            <i className="ri-home-4-line text-base" />
            返回首页
          </Link>
          <Link
            to="/category/全部"
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300 px-4 py-2.5 text-sm text-foreground-200 transition-colors hover:border-primary-500/60 hover:text-primary-300"
          >
            浏览全部影片
          </Link>
        </div>
      </div>
    </div>
  );
}